// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._YmT1oy6v4XOCWsO_CT6{flex-shrink:0;width:180px}.enXf2K40PDYTwKt7Caj_{flex:1;overflow:auto}.CvvQTZaaL2QGKW4EWdNb{align-items:center;height:32px;padding:0 8px;display:flex}.qsDlPoCZVjsThFdGMXCq{position:relative}.UG7yTZgtwfArWzQz0tbd{margin:0}.PiKc9t5CLDwtL8CUYwDm{position:absolute;right:-13px}.vgSBxI87YUML_64Hf1Ma{display:flex;position:absolute;top:8px;right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `_YmT1oy6v4XOCWsO_CT6`,
	"content": `enXf2K40PDYTwKt7Caj_`,
	"menuTitle": `CvvQTZaaL2QGKW4EWdNb`,
	"menuItem": `qsDlPoCZVjsThFdGMXCq`,
	"menuItemLabel": `UG7yTZgtwfArWzQz0tbd`,
	"statusComingSoon": `PiKc9t5CLDwtL8CUYwDm`,
	"alertIconOverlay": `vgSBxI87YUML_64Hf1Ma`
};
export default ___CSS_LOADER_EXPORT___;
